import { createSelector } from '@ngrx/store';
import { AppState } from '@nx-customer-apps/shared/interfaces';

export namespace GlobalSelectors {
    const globalState = (state: AppState) => state;

    export const getGlobalState = () => createSelector(globalState, (state: AppState) => state);
}
